import { render, staticRenderFns } from "./ITPro_TV_Adam.vue?vue&type=template&id=919c2972&"
import script from "./ITPro_TV_Adam.vue?vue&type=script&lang=js&"
export * from "./ITPro_TV_Adam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports